// extracted by mini-css-extract-plugin
export default {"container":"Footnote--container--ycSgk","icon":"Footnote--icon--GFY20","row":"Footnote--row--DI2ag"};